import { render, staticRenderFns } from "./DynamicTemplateUpdate.vue?vue&type=template&id=f99ea1b8"
import script from "./DynamicTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./DynamicTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports